export default __webpack_public_path__ + "static/media/mapaCifras.b71a1b89.png";